import { render } from "./schedule-wednesday.vue?vue&type=template&id=5b6bf9d0"
import script from "./schedule-wednesday.vue?vue&type=script&lang=js"
export * from "./schedule-wednesday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__